import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { doc, setDoc, serverTimestamp, collection } from "firebase/firestore"; 

const DeleteAccountPage = () => {
  const [requestSubmitted, setRequestSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "", 
    reasons: {
      unwanted_emails: false,
      privacy_concerns: false,
      found_alternative: false,
      other: false,
    },
    otherReason: "",
  });
  useEffect(() => {
    setFormData((prevState) => ({
      ...prevState,
      timeStamp: serverTimestamp(), // Mettre à jour timeStamp avec serverTimestamp() lors du montage du composant
    }));
  }, []);
  
    const formatDate = (timestamp) => {
    if (!timestamp) return ""; // Vérifier si timestamp est null ou non défini
     // Vérifier si le timestamp est valide
     if (timestamp instanceof Date && !isNaN(timestamp)) {
        return timestamp.toLocaleString();
      } else {
        // Si le timestamp est invalide, retourner une chaîne vide
        return "";
      }
  };

  const demandeForDelete = `
  <html>
    <head>
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no" />
    </head>
    <body>
    <header>
    <h1>L´utilisateur suivant vous demande de supprimer ses Informations de votre Base de donnée
    </h1>
    <address>
      <p>Nom: ${formData.name}</p>
      <p>Adresse: ${formData.email}</p>
      <p>Date: ${formatDate(formData.timeStamp)}</p>
    </address>   
  </header> 
  <article>
    <h1>Raison de la suppression</h1>
    <p>${
      formData.reasons.unwanted_emails
        ? "Je reçois trop d'emails indésirables."
        : ""
    }</p>
    <p>${
      formData.reasons.privacy_concerns
        ? "Je suis préoccupé par ma vie privée."
        : ""
    }</p>
    <p>${
      formData.reasons.found_alternative
        ? "J'ai trouvé une alternative à cette application."
        : ""
    }</p>
    <p>${formData.reasons.other ? formData.otherReason : ""}</p>      
  </article>
     
  <aside>
    <h1><span>Important</span></h1>
    <div>
      <p>Veuillez supprimer les données dans les 48h</p>
    </div>
  </aside> 
    </body>
  </html>
  `;

  const sendPerMail = async () => {
    // Add a new document with a generated id
    const newEmail = doc(collection(db, "mail"));

    await setDoc(newEmail, {
      to: ["amadourys15@yahoo.com"],
      message: {
        subject: "Demande de Suppression de données",
        text: "This is the plaintext section of the email body.",
        html: demandeForDelete,
        /* attachments: [
          {
            content: html,
            filename: uri
          }
        ]*/
      },
    });
    setRequestSubmitted(true)
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setFormData({
        ...formData,
        reasons: { ...formData.reasons, [name]: checked },
        otherReason: "",
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Envoyer les données du formulaire pour traitement
    console.log(formData);
    // Réinitialiser le formulaire après soumission
    setFormData({
      name: "",
      email: "",
      reasons: {
        unwanted_emails: false,
        privacy_concerns: false,
        found_alternative: false,
        other: false,
      },
      otherReason: "",
    });
    sendPerMail();
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Supprimer votre compte</h2>
      {requestSubmitted ? (
        <div style={styles.message}>
          <p>Votre demande de suppression de compte a été prise en compte.</p>
          <p>
            Un e-mail de confirmation vous sera envoyé avec un lien pour
            confirmer la suppression.
          </p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Nom: </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              style={styles.input}
              required
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Email: </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              style={styles.input}
              required
            />
          </div>
          <div style={styles.formGroup}>
            <p style={styles.label}>Raisons de la suppression:</p>
            <label style={styles.checkboxLabel}>
              <input
                type="checkbox"
                name="unwanted_emails"
                checked={formData.reasons.unwanted_emails}
                onChange={handleChange}
                style={styles.checkbox}
              />
              Je reçois trop d'emails indésirables.
            </label>
            <label style={styles.checkboxLabel}>
              <input
                type="checkbox"
                name="privacy_concerns"
                checked={formData.reasons.privacy_concerns}
                onChange={handleChange}
                style={styles.checkbox}
              />
              Je suis préoccupé par ma vie privée.
            </label>
            <label style={styles.checkboxLabel}>
              <input
                type="checkbox"
                name="found_alternative"
                checked={formData.reasons.found_alternative}
                onChange={handleChange}
                style={styles.checkbox}
              />
              J'ai trouvé une alternative à cette application.
            </label>
            <label style={styles.checkboxLabel}>
              <input
                type="checkbox"
                name="other"
                checked={formData.reasons.other}
                onChange={handleChange}
                style={styles.checkbox}
              />
              Autre (veuillez préciser):
            </label>
            <input
              type="text"
              name="otherReason"
              value={formData.otherReason}
              onChange={handleChange}
              style={styles.input}
              disabled={!formData.reasons.other}
            />
          </div>
          <button type="submit" style={styles.button}>
            Demander la suppression du compte
          </button>
        </form>
      )}
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "400px",
    margin: "auto",
    padding: "20px",
    border: "1px solid #ccc",
    borderRadius: "5px",
  },
  title: {
    textAlign: "center",
    marginBottom: "20px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  formGroup: {
    marginBottom: "15px",
  },
  label: {
    marginBottom: "5px",
  },
  input: {
    padding: "10px",
    borderRadius: "5px",
    border: "1px solid #ccc",
  },
  checkboxLabel: {
    marginBottom: "5px",
    display: "block",
  },
  checkbox: {
    marginRight: "5px",
  },
  button: {
    padding: "10px",
    borderRadius: "5px",
    border: "none",
    backgroundColor: "#007bff",
    color: "#fff",
    cursor: "pointer",
  },
};

export default DeleteAccountPage;
